import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import { OidcProvider } from 'redux-oidc';
import store from "./redux/store";
import userManager from './helpers/userManage';
import * as Sentry from '@sentry/react';

import App from "./App";
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://790afc4895b1c1a081fde273379018b5@o880208.ingest.sentry.io/4506556928032768',
    integrations: [
      // new Sentry.BrowserTracing({
      //   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      //   tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
      // }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
ReactDOM.render(
  <Provider store={store}>
    <OidcProvider store={store} userManager={userManager}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
    </OidcProvider>
  </Provider>,
  document.getElementById("root")
);
/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
serviceWorker.unregister();
